import { Stack, Text } from "@fluentui/react";
import { Card } from "@fluentui/react-components";
import { ITimelineChartData } from "models/IChartData";

export const CustomTimelineChart = ({ chartData }: { chartData: ITimelineChartData }) => {
    const { summary, events } = chartData;

    const colors = ["#4CAF50", "#FFC107", "#2196F3", "#FF5722", "#9C27B0"];

    return (
        <Stack tokens={{ childrenGap: 20 }} style={{ width: "100%", maxWidth: "800px" }}>
            <Text variant="medium">{summary}</Text>
            <Stack tokens={{ childrenGap: 10 }}>
                {events.map((event, index) => (
                    <Card key={index} style={{ display: "flex", borderLeft: `5px solid ${colors[index % colors.length]}`, padding: "15px" }}>
                        <Stack tokens={{ childrenGap: 8 }}>
                            <Text variant="large" style={{ fontWeight: "bold" }}>{event.label}</Text>
                            <Text variant="small" style={{ color: "#666" }}>{event.timestamp}</Text>
                            <ul style={{ margin: 0, paddingLeft: "15px" }}>
                                {event.details.map((detail, i) => (
                                    <li key={i} style={{ fontSize: "14px" }}>{detail}</li>
                                ))}
                            </ul>
                        </Stack>
                    </Card>
                ))}
            </Stack>
        </Stack>
    );
};